import type { AlertT } from "./types";

class AlertStateManager {
  private static instance: AlertStateManager;

  currentAlert?: AlertT = undefined;

  subscribers: Array<(alert?: AlertT) => void>;

  constructor() {
    this.currentAlert = undefined;
    this.subscribers = [];
  }

  public static getInstance(): AlertStateManager {
    if (!AlertStateManager.instance) {
      AlertStateManager.instance = new AlertStateManager();
    }

    return AlertStateManager.instance;
  }

  createAlert = (alert: AlertT) => {
    if (this.currentAlert) {
      this.dismissAlert();
    }
    this.currentAlert = alert;
    this.publishAlert();
  };

  publishAlert = () => {
    for (const subscriber of this.subscribers) {
      subscriber(this.currentAlert);
    }
  };

  dismissAlert = () => {
    this.currentAlert = undefined;
    this.publishAlert();
  };

  subscribe = (subscriber: (alert?: AlertT) => void) => {
    this.subscribers.push(subscriber);

    return () => {
      const index = this.subscribers.indexOf(subscriber);
      this.subscribers.splice(index, 1);
    };
  };

  alert = ({ title, body, variant, onDismiss }: AlertT) => {
    this.createAlert({ title, body, variant, onDismiss });
  };

  error = ({ title, body, onDismiss }: AlertT) => {
    this.createAlert({ title, body, variant: "default", onDismiss });
  };
}

export const AlertState = AlertStateManager.getInstance();

export const alerter = Object.assign(AlertState.alert, {
  error: AlertState.error,
});
